// API Configuration
export const API_CONFIG = {
  BASE_URL: (import.meta as any).env?.VITE_API_URL || 'http://localhost:3000',
  API_VERSION: 'v1',
  TIMEOUT: 30000, // 30 seconds
};

export const getApiUrl = (endpoint: string): string => {
  return `${API_CONFIG.BASE_URL}/api/${API_CONFIG.API_VERSION}${endpoint}`;
};

// Storage keys
export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'dashboard_access_token',
  REFRESH_TOKEN: 'dashboard_refresh_token',
  USER: 'dashboard_user',
} as const;

// HTTP Methods
export const HTTP_METHODS = {
  GET: 'GET',
  HEAD: 'HEAD',
  POST: 'POST',
  PUT: 'PUT',
  DELETE: 'DELETE',
  PATCH: 'PATCH',
} as const;
